import React from 'react'
import Section from '../../../../components/section'
import Text from '../../../../components/text'
import Input from '../../../../components/input'
import Button from '../../../../components/button'
import useLogin from '../../login/hooks/login.hook'
import {useFormik} from "formik";
import * as Yup from "yup";
import Flex from '../../../../components/flex'
import EyeIcon from '../../../../components/svg/EyeIcon'
import {toast} from "react-toastify";
import useHttpHandler from "../../../../hooks/httpHandler";

const ChangePasswordView = () => {
    const {
        showPassword,
        showPasswordClick,
        showOldPassword,
        showOldPasswordClick,
        showConfirmPassword,
        showConfirmPasswordClick,
        uppercaseRegex,
        lowercaseRegex,
        numericRegex,
        nonalphanumeric,
        charactersRegex,
        goBackToLogin
    } = useLogin();
    const {post} = useHttpHandler()
    const onSubmitChangePassword=(values, actions)=>{
        post('auth/change-password', values).then((res)=>{
            actions.setSubmitting(false)
            toast.success('Password changed successfully')
            goBackToLogin()
        }).catch(err => {
            actions.setSubmitting(false)
        })

    }
    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
        },
        validationSchema: Yup.object({
            oldPassword: Yup.string().required('Please enter a old password'),
            newPassword: Yup.string()
                .min(9, 'Please enter a password')
                .matches(uppercaseRegex, 'At least 1 capital letter required')
                .matches(lowercaseRegex, 'At least 1 small letter required')
                .matches(numericRegex, 'At least 1 number required')
                .matches(nonalphanumeric, 'At least 1 special character required')
                .matches(charactersRegex, 'At least 1 special character (@, #, $, *) required')
                .required('Please enter a password'),
            confirmNewPassword: Yup.string().min(9, 'Please enter a password').required('Please re-enter password').oneOf([Yup.ref('newPassword'), null], 'Passwords must a match'),
        }),
        onSubmit: (values, actions) => {
            const body = {
                new_password: values?.newPassword,
                old_password: values?.oldPassword
            }
            onSubmitChangePassword(body, actions)
        }
    });
    return (
        <>
            <Section>
                <div className="row">
                    <div className="col-12 col-md-5 mx-auto">
                        <Text type="H1" text="Change Password" />
                        <form onSubmit={formik.handleSubmit}>
                            <div className="formBox">
                                <Input
                                    label="Old Password"
                                    type={showOldPassword ? 'text' : 'password'}
                                    name="oldPassword"
                                    placeholder="********"
                                    value={formik.values.oldPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.oldPassword && formik.errors.oldPassword ? (
                                        formik.errors.oldPassword
                                    ) : null}
                                    icon={
                                        <span onClick={showOldPasswordClick}><EyeIcon visible={showOldPassword}/></span>
                                    }
                                    hint="Min 9, One Upper , One Lower and One special character"
                                />
                            </div>
                            <div className="formBox">
                                <Input
                                    label="New Password"
                                    type={showPassword ? 'text' : 'password'}
                                    name="newPassword"
                                    placeholder="********"
                                    value={formik.values.newPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.newPassword && formik.errors.newPassword ? (
                                        formik.errors.newPassword
                                    ) : null}
                                    icon={
                                        <span onClick={showPasswordClick}><EyeIcon visible={showPassword}/></span>
                                    }
                                    hint="Min 9, One Upper , One Lower and One special character"
                                />
                            </div>
                            <div className="formBox">
                                <Input
                                    label="Confirm New Password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    name="confirmNewPassword"
                                    placeholder="********"
                                    value={formik.values.confirmNewPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.confirmNewPassword && formik.errors.confirmNewPassword ? (
                                        formik.errors.confirmNewPassword
                                    ) : null}
                                    icon={
                                        <span onClick={showConfirmPasswordClick}><EyeIcon visible={showConfirmPassword}/></span>
                                    }
                                    hint="Please enter password again"
                                />
                            </div>
                            <Flex justifyContent="end" className="mb-48">
                                <Button
                                    link
                                    text="Back to login"
                                    onClick={goBackToLogin}
                                    type="button"
                                />
                            </Flex>
                            <Flex justifyContent="center" className="mb-48">
                                <Button
                                    type="submit"
                                    text="Update"
                                    large
                                    isSubmitting={formik.isSubmitting}
                                    disabled={formik.isSubmitting}
                                />
                            </Flex>
                        </form>
                    </div>
                </div>
            </Section>
        </>
    )
}

export default ChangePasswordView